// extracted by mini-css-extract-plugin
export var askAiIcon = "_nc-j";
export var category = "_nc-9";
export var categoryHeader = "_nc-e";
export var container = "_nc-0";
export var group = "_nc-a";
export var groupItems = "_nc-f";
export var groupSeparator = "_nc-k";
export var loading = "_nc-1";
export var noResults = "_nc-3";
export var placeholder = "_nc-2";
export var resultContent = "_nc-5";
export var resultIcon = "_nc-c";
export var resultItem = "_nc-g";
export var resultMeta = "_nc-8";
export var resultSubtitle = "_nc-7";
export var resultSuffix = "_nc-i";
export var resultTitle = "_nc-6";
export var resultsList = "_nc-4";
export var searchGroup = "_nc-d";
export var selected = "_nc-h";
export var subgroup = "_nc-b";